/**
 * The pure model of Link all in the Unlinked section (1.J stage 3, deliverable 33): the request
 * from a preview, and the words, which are 1.N-1 deliverable 18's with a proper singular at a
 * count of 1.
 */
import type { LinkAllPreviewV1, LinkAllRequestV1 } from '@codex/contracts';
import { mentionLinkBody } from './unlinked-model.js';

export const LINK_ALL_EMPTY_TEXT = 'No unlinked mentions remain.';
export const LINK_ALL_FAILED_TEXT = "The mentions couldn't be linked. Try again.";
export const LINK_ALL_PREVIEW_FAILED_TEXT = "The preview couldn't be loaded.";

const mentions = (n: number) => `${n} ${n === 1 ? 'mention' : 'mentions'}`;

/** Every previewed occurrence as `mentions.link` names it. */
export function toLinkAllRequest(preview: Pick<LinkAllPreviewV1, 'occurrences'>): LinkAllRequestV1 {
  return { occurrences: preview.occurrences.map(mentionLinkBody) };
}

/** The confirm button: "Link 1 mention", "Link 3 mentions". */
export function linkAllButtonText(count: number): string {
  return `Link ${mentions(count)}`;
}

/**
 * What the GM is told afterwards: "Linked 3 mentions.", then, when `total` is past the listed
 * occurrences, "The first 2 are linked now; press Link again for the rest." ("The first 1 is
 * linked now; …").
 */
export function linkAllResultText(linked: number, listed: number, total: number): string {
  const done = `Linked ${mentions(linked)}.`;
  if (total <= listed) return done;
  return `${done} The first ${listed} ${listed === 1 ? 'is' : 'are'} linked now; press Link again for the rest.`;
}
